import {t} from 'i18next';
import moment from 'moment';
import {Card} from 'primereact/card';
import {Column} from 'primereact/column';
import {DataTable} from 'primereact/datatable';
import {TabPanel, TabView} from 'primereact/tabview';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDetailsContainer from '../baseContainers/BaseDetailsContainer';
import ActionLink from '../components/ActionLink';
import DivContainer from '../components/DivContainer';
import YesNoDialog from '../components/YesNoDialog';
import InputCalendarComponent from '../components/inputs/InputCalendarComponent';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import ProjectService from '../services/ProjectService';
import {withRouter} from 'react-router-dom';
import AuthService from '../services/AuthService';
import LogEntryListContainer from './LogEntryListContainer';
import ReportedUserDayService from '../services/userReport/ReportedUserDayService';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import Constants from '../utils/constants';
import InputTextareaComponent from '../components/inputs/InputTextareaComponent';
import SimpleReactValidator from '../components/validator';
import ActionButton from '../components/ActionButton';
import { styled } from '@mui/material';

class UserDayDetailsContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new ReportedUserDayService());
        
        this.projectService = new ProjectService();
        this.authService = new AuthService();


        const queryParams = new URLSearchParams(this.props.location.search);
        let activeIndexParam = parseInt(queryParams.get('activeIndex'));
        const projectId = queryParams.get('projectId')
        const userId = queryParams.get('userId');
        
        this.state = {
            activeIndex: activeIndexParam ? activeIndexParam : 0,
            projectId: projectId,
            userId : userId,
            loading: true,
            day: queryParams.get('day'),
            showFooterButtons: false,
            downloadingPdf: false,
            elementId: props.elementId,
            showConfirmRejectDialog: false,
            showConfirmReopenDialog: false,
            showApproveAlarmDialog: false,
            showConfirmAcceptDialog: false,
            rejectReason: null,
            projects: [],
            activities: [],
            editingFlag: false,
            viewMode: props.viewMode,
            activeFieldsModel: {
                map: {}
            },
            element:{
                day: queryParams.get('day'),
                events: []
            },
            newElement: {
                client: {},
                project: {},
                activity: undefined,
                comment: undefined,
                userContractType: undefined,
                event: {
                    status: {
                        label: 'Do akceptacji',
                        enumValue: 'TO_APPROVE'
                    },
                    userTime: undefined,
                    timeFrom: undefined,
                    timeTo: undefined,
                    creativeTime: undefined,
                    comment: undefined,
                    selectedDay: queryParams.get('day'),
                }
            },
        };
        this.showRejectConfirmation = this.showRejectConfirmation.bind(this);
        this.hideRejectConfirmation = this.hideRejectConfirmation.bind(this);
        this.showAcceptConfirmation = this.showAcceptConfirmation.bind(this);
        this.hideAcceptConfirmation = this.hideAcceptConfirmation.bind(this);

        this.handleAddNewActivity = this.handleAddNewActivity.bind(this);
        this.handleEditActivity = this.handleEditActivity.bind(this);
        this.isRowActive = this.isRowActive.bind(this);
        this.normalizeListAfterRowEdit = this.normalizeListAfterRowEdit.bind(this);
        this.goToEditViewMode = this.goToEditViewMode.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.disableAllInplaceComponents = this.disableAllInplaceComponents.bind(this);
        this.setUnlockDialogVisible = this.setUnlockDialogVisible.bind(this);
        this.renderDetails = this.renderDetails.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.update = this.update.bind(this);
        this.handleApply = this.handleApply.bind(this);
        this.persistSuccessfullUpdateMessage = this.persistSuccessfullUpdateMessage.bind(this) //TODO 

        this.rowValidator = new SimpleReactValidator({}, this.translate);
        this.addRowValidator = new SimpleReactValidator({}, this.translate);

        const getMinutes = (moment) => {
            const hours = moment.hours();
            const minutes = moment.minutes();
            return hours * 60 + minutes;
        }

        this.addRowValidator.addCustomRule('time_validation', t('userReporting.moreThanZeroValidaton'),
            (value, params) => {
                const element = this.state.newElement;
                if (!this.authService.getProfile().timeReportingStartEndDateRequired) {
                    return element.event.userTime !== undefined && moment(element.event.userTime).format('HH:mm') !== '00:00'
                } else {
                    return element.event.timeFrom !== undefined
                        && element.event.timeTo !== undefined
                        && moment(element.event.timeFrom).format('HH:mm') !== '00:00'
                        && moment(element.event.timeTo).format('HH:mm') !== '00:00'
                }
            }, (message, value) => message, true
        );

        this.addRowValidator.addCustomRule('from_to_validation', t('userReporting.fromToValidation'),
            (value, params) => {
                if (!this.authService.getProfile().timeReportingStartEndDateRequired) {
                    return true;
                } else {
                    return this.state.newElement.event.timeFrom !== undefined
                        && this.state.newElement.event.timeTo !== undefined
                        && getMinutes(moment(this.state.newElement.event.timeFrom)) < this.getMinutes(moment(this.state.newElement.event.timeTo))
                }
            }, (message, value) => message, true
        );

        this.addRowValidator.addCustomRule('creative_time_validation', 'Czas pracy twórczej nie może przekraczać czasu pracy',
            (value, params) => {
                const userTime = this.state.newElement.event.userTime;
                const creativeTime = this.state.newElement.event.creativeTime;

                if (userTime && creativeTime) {
                    return getMinutes(moment(creativeTime))<= getMinutes(moment(userTime))
                }else{
                    return true;
                }
            }, (message, value) => message, true
        );

        this.addRowValidator.addCustomRule('record_already_assigned', t('userReporting.record_already_assigned'),
            (value, params) => {
                const { element } = this.state;
                let result = true;
                if (element.activity && element.activity.id
                    && element.project && element.project.id) {
                    this.state.element.events.forEach((x) => {
                        const projectId = x?.project?.id;
                        const activityId = x?.activity?.id;
                        if (element.project.id === projectId && activityId === element.activity.id
                            && !this.authService.getProfile().timeReportingStartEndDateRequired) {

                            result = false;
                        }
                    })
                }
                return result;
            }, (message, value) => message
        )

        this.addRowValidator.addCustomRule('record_already_assigned', t('userReporting.record_already_assigned'),
            (value, params) => {
                const element = this.state.newElement
                let result = true;

                this.state.element.events.forEach((x) => {
                    if (element?.activity?.id === x.activity.id && !this.authService.getProfile().timeReportingStartEndDateRequired) {
                        result = false;
                    }
                })
                return result;
            }, (message, value) => message, true
        )

        this.rowValidator.addCustomRule('creative_time_validation', 'Czas pracy twórczej nie może przekraczać czasu pracy',
            (value, params) => {
                const index = params[0];
                const userTime = this.state.element.events[index]?.event.userTime;
                const creativeTime = this.state.element.events[index]?.event.creativeTime;

                if (userTime && creativeTime) {
                    return getMinutes(moment(creativeTime)) <= getMinutes(moment(userTime));
                }else{
                    return true;
                }
            }, (message, value) => message, true
        );


        this.rowValidator.addCustomRule('record_already_assigned', t('userReporting.record_already_assigned'),
            (value, params) => {
                const element = this.state.element.events[params[0]];
                let result = true;

                if (element?.activity && element?.activity.id) {
                    this.state.element.events.forEach((x) => {
                        const activityId = x?.activity?.id;
                        if (x.event.id !== element.event.id &&
                            activityId === element.activity.id && !this.authService.getProfile().timeReportingStartEndDateRequired) {
                            result = false;
                        }
                    })
                }
                return result;
            }, (message, value) => message
        )
        this.rowValidator.addCustomRule('from_to_row_validation', t('userReporting.fromToValidation'),
            (value, params) => {
                if (!this.authService.getProfile().timeReportingStartEndDateRequired) {
                    return true;
                } else {
                    const index = params[0];
                    const from = moment(this.state.element.events[index].event.timeFrom).toDate()
                    const to = moment(this.state.element.events[index].event.timeTo).toDate()
                    return from.getMinutes() + from.getHours() * 60 <
                        to.getMinutes() + to.getHours() * 60
                }
            }, (message, value) => message, true
        );


        this.rowValidator.addCustomRule('more_than_zero_row', t('userReporting.moreThanZeroValidaton'),
            (value, params) => {
                const index = params[0];

                if (!this.authService.getProfile().timeReportingStartEndDateRequired) {
                    const userTime = this.state.element.events[index].event.userTime;
                    return userTime !== undefined &&
                    moment(userTime).isValid() &&
                    moment(userTime).format('HH:mm') !== '00:00'
                } else {
                    const from = this.state.element.events[index].event.timeFrom;
                    const to = this.state.element.events[index].event.timeTo;
                    return from !== undefined
                        && to !== undefined
                        && moment(from).isValid()
                        && moment(to).isValid()
                        && moment(from).format('HH:mm') !== '00:00'
                        && moment(to).format('HH:mm') !== '00:00'
                }
            }, (message, value) => message, true
        );
    }


    translateLevel(l) {
        if (l === 'CREATED') {
            return t('userReporting.create');
        }
        if (l === 'TO_APPROVE') {
            return t('userReporting.toApprove');
        }
        if (l === 'APPROVED') {
            return t('userReporting.approved');
        }
    }

    onInputClick(id) {
        const input = document.getElementById(id)
        input.focus();
        input.setSelectionRange(0, 0);
    }

    formatNumber(number) {
        if (!number) {
            return 0;
        }
        const formatter = new Intl.NumberFormat('pl-PL', {
            style: 'decimal',
            currency: 'PLN',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        const formattedNumber = formatter.format(number);
        return formattedNumber;
    }

    getClosedInplaceComponentsMapForRow(rowIndex) {
        let data = this.state.activeFieldsModel.map;
        for (const [key, value] of Object.entries(data)) {
            const arr = key.split(',').map(Number);
            if (arr[0] === rowIndex) {
                data[[arr[0], arr[1]]] = false; //"zamknij" wszystkie inplace z danego wiersza
            }
        }
        return data;
    }

    cancelRowEdit(rowIndex) {
        const data = this.getClosedInplaceComponentsMapForRow(rowIndex);

        this.setState({
            activeFieldsModel: {
                map: data
            }
        })
    }

    updateElement(data) {
        if (data.date) {
            data.date = new Date(moment(data.date));
        }

        if (data.events) {
            data.events = this.updateListElements(data.events);
        }

        let element = data;
        element.day = moment(this.state.element.day).toDate()
 
        this.setState(
            {
                element: element,
            },
            () => {
                this.initAfterSetElement();
            }
        )
    }


    initBeforeSetElement() {
        this.getProject();
        this.setState({showFooterButtons: true});
    }

    initAfterSetElement() {
        super.initAfterSetElement();
    }

    getProject() {
        if (this.state.projectId) {
            this.projectService
                .get(this.state.projectId)
                .then((project) => {
                    this.setState((prev) => ({
                        project: project,
                        newElement: {
                            ...prev.newElement,
                            project: project,
                            client: project.client
                        }
                    }))
                })
                .catch(() => {
                    this.showErrorMessage(t('userReporting.singleProjectError'));
                })

            this.projectService
                .getTimeReportingActivities(this.state.projectId)
                .then(activities => {
                    this.setState(({
                        activities: activities
                    }))
                }).catch(() => {
                    this.setState({
                        activities: []
                    })
                    this.showErrorMessage(t('userReporting.activityError'))
                })
        }
    }

    refreshAfterUpdate() {
        const url = `?day=${this.state.element.day}&projectId=${this.state.projectId}&userId=${this.state.userId}&activeIndex=${this.state.activeIndex}`
        this.props.history.push(url);
        this.refreshTable()
    }

    createOrUpdate() {
        let element = this.state.element;
        element.projectId = this.state.projectId;
        const { userId } = this.state;
       
        this.scrollToTop();
        if (userId) {
            this.service
                .update(element, userId)
                .then((response) => {
                    this.setState({
                        editingFlag: false,
                        viewMode: 'VIEW',
                        activeFieldsModel: {
                            map: {}
                        }
                    }, ()=>{
                        this.refreshAfterUpdate();
                    })
                })
                .catch((err) => {
                    this.setState({
                        editingFlag: true,
                        viewMode: 'EDIT'
                    })
                    this.unblockUi();
                    this.showErrorMessage(err.message)
                });
        }
    }

    update() {
        let element = this.state.element;
        element.projectId = this.state.projectId;
        const { userId } = this.state;

        this.scrollToTop();
        if (userId) {
            this.service
                .update(element, userId)
                .then(() => {
                    this.setState({
                        activeFieldsModel: {
                            map: {}
                        }
                    }, ()=>{
                        this.refreshAfterUpdate();
                        this.showSuccessMessage(t('reportedDay.updateMessage'))
                    })
                })
                .catch((err) => {
                    this.unblockUi();
                    this.showErrorMessage(err.message)
                });
        }
    }
    

    handleFormSubmit(event) {
        if (event !== undefined) {
            event.preventDefault();
        }
    }

    goToEditViewMode() {
        this.blockUi();

        const activeIndex= this.state.activeIndexParam;
        const projectId = this.state.projectId;
        const userId = this.state.userId;

        const day = this.state.day;
        const { editUrl } = this.props;


        const activeIndexParam = activeIndex ? `&activeIndex=${activeIndexParam}` : '';
        let urlParams = `${this.state.elementId}?day=${day}&projectId=${projectId}&userId=${userId}` + activeIndexParam

        window.location.href = this.navigationContext.addNavigationContextToUrl(editUrl + urlParams);
    }

    goToViewMode(){
        this.blockUi();

        const activeIndex= this.state.activeIndexParam;
        const projectId = this.state.projectId;
        const userId = this.state.userId;

        const day = this.state.day;
        const { detailUrl } = this.props;


        const activeIndexParam = activeIndex ? `&activeIndex=${activeIndexParam}` : '';
        let urlParams = `${this.state.elementId}?day=${day}&projectId=${projectId}&userId=${userId}` + activeIndexParam

        window.location.href = this.navigationContext.addNavigationContextToUrl(detailUrl + urlParams);
    }

    handleCancel(){
       this.goToViewMode();
    }

    persistSuccessfullUpdateMessage(){
        this.persistMessage('success', '', t('reportedDay.updateMessage'));
    }

    goToList() {
        this.blockUi();
        const { backUrl } = this.props;
        this.persistSuccessfullUpdateMessage();
        window.location.href = this.navigationContext.addNavigationContextToUrl(backUrl);
    }


    handleSave(e) {
        if (this.rowValidator.allValid()) {
            this.createOrUpdate()
            this.refreshTable();
            this.goToList(); //przejdz na liste po zapisie  
        } else {
            this.rowValidator.showMessages();
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    handleApply() {
        if (this.rowValidator.allValid()) {
            this.update()
            //brak przejscia na inny widok jeslii kliknie zastosuj
        } else {
            this.rowValidator.showMessages();
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    prepareFooterItems() {
        const result = [];
        const {viewMode} = this.props;

        const roleEdit = this.authService.isUserInRole('ROLE_TIMESHEET_EDIT');

        const isAllApproved = this.state.element?.events?.filter(
            (x) => x.event.acceptLevel === Constants.PM_APPROVED_LEVEL)
            .length === this.state.element?.events?.length
        const atLeastOneEventToUnlockExists = this.state.element?.events?.filter((
            x) => x.event.acceptLevel === Constants.PM_APPROVED_LEVEL)
            .length > 0
        const recordToRejectExists = this.state.element?.events?.filter(
            (x) => x.event.acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL)
            .length > 0;


        const roleApprove = this.authService.isUserInRole('ROLE_TIMESHEET_APPROVE'); 
        switch (viewMode) {
            case 'NEW':
                break;
            case 'EDIT':
            case 'VIEW':
                if (roleEdit || roleApprove) {
                    if (this.state.viewMode === 'EDIT') {
                        if (roleEdit) {
                            result.push({
                                id: "apply-footer-btn",
                                label: t('global.applyButton'),
                                className: 'float-right',
                                onClick: this.handleApply,
                                disabled: this.state.element?.events.length  < 1
                            })
                            result.push({
                                id: 'save-button',
                                label: t('global.saveButton'),
                                className: 'float-right',
                                onClick: this.handleSave,
                                disabled: this.state.element?.events.length  < 1
                            });
                        }
                        result.push({
                            label: 'Anuluj',
                            id: 'cancel-button',
                            className: 'cancel-button white',
                            onClick: this.handleCancel
                        });
                    } else {        
                        if (roleApprove) {
                            if (!isAllApproved) {
                                if (this.state.element.events.length > 0) {
                                    result.push({ label: t('global.accept'), className: 'float-right', onClick: this.showAcceptConfirmation });
                                }
                                if(roleEdit){
                                    result.push({
                                        label: t('global.editButton'),
                                        id: 'edit-button',
                                        className: 'float-right',
                                        onClick: this.goToEditViewMode
                                    });
                                }
                               
                            }
                            if (recordToRejectExists || !roleEdit) {
                                result.push({ label: t('global.reject'), className: 'fullred float-right', onClick: this.showRejectConfirmation });
                            }
                            if (atLeastOneEventToUnlockExists) {
                                result.push({ label: t('global.unlock'), className: 'float-right', onClick: this.setUnlockDialogVisible });
                            }
                        }
                    }
                }
                break;
            default:
                break;
        }

        return result;
    }


    setUnlockDialogVisible(){
        this.setState({unlockDialogVisible: true})
    }

    showRejectConfirmation() {
        this.setState({showConfirmRejectDialog: true});
    }

    hideRejectConfirmation() {
        this.setState({showConfirmRejectDialog: false});
    }

    showAcceptConfirmation() {
        this.setState({showConfirmAcceptDialog: true});
    }

    hideAcceptConfirmation() {
        this.setState({showConfirmAcceptDialog: false});
    }

    handleReject() {
        this.blockUi();
        const { rejectReason } = this.state;
        const { userId } = this.state;
        this.service
            .reject(this.state.day, this.state.projectId, rejectReason, userId)
            .then((result) => {
                this.setState({
                    rejectReason: null
                })
                this.refreshTable();
                this.hideRejectConfirmation();
                this.unblockUi();
                this.showSuccessMessage(t('userReporting.rejectSuccess'));
            })
            .catch((err) => {
                this.showErrorMessage(t('userReporting.rejectErrorMessage'));
                this.refreshTable();
                this.hideRejectConfirmation();
                this.unblockUi();
            });
    }

    handleUnlockUserDay() {
        this.blockUi();
        const { userId } = this.state;
        this.service
            .open(this.state.day, this.state.projectId, userId)
            .then((x) => {
                this.refreshTable();
                this.unblockUi();
                this.showSuccessMessage(t('userReporting.unblockSuccess'))
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.unblockUi();
                this.showSuccessMessage(t('userReporting.unblockError'))
            })
    }
    handleAcceptUserDay() {
        this.blockUi();
        const { userId } = this.state;
        this.service
            .approve(this.state.day, this.state.projectId, userId)
            .then((x) => {
                this.refreshTable()
                this.unblockUi()
                this.showSuccessMessage(t('userReporting.confirmSuccess'))
            })
            .catch((err) => {
                this.showErrorMessage(err.message)
                this.unblockUi()
                this.showSuccessMessage(t('userReporting.confirmError'))
            })
    }

    isPdfButtonRendered() {
        return false;
    }

    getPdfDownloadLabel() {
        return null;
    }

    
    formatTime(time) {
        if (time) {
            const hours = Math.floor(time / 60);
            const mins = time % 60;
            return `${hours}:${mins.toString().padStart(2, '0')}`;
        } else {
            return '';
        }
    }


    canViewCardDetails() {
        return this.authService.isUserInAnyRoleArray(['ROLE_TIMESHEET_VIEW'])
    }


    createQueryString(queryObject = {}) {
        let queryString = Object.keys(queryObject)
            .filter((key) => queryObject[key] && !(Array.isArray(queryObject[key]) && !queryObject[key].length))
            .map((key) => {
                return Array.isArray(queryObject[key])
                    ? queryObject[key].map((item) => `${encodeURIComponent(key)}=${encodeURIComponent(item)}`).join('&')
                    : `${encodeURIComponent(key)}=${encodeURIComponent(queryObject[key])}`;
            })
            .join('&');
        return queryString ? `?${queryString}` : '';
    }


    renderCard() {
        return (
            <div style={{minHeight: '900px'}}>
                <Card className='details-card' footer={this.state.showFooterButtons && this.renderFooter()} header={this.renderHeader()}>
                    <form onSubmit={this.handleFormSubmit} noValidate autoComplete='off'>
                        {this.renderDetails()}
                    </form>
                </Card>
            </div>
        );
    }

    getClientColumn(rowData, prop) {
        const { rowIndex } = prop;

        return (
            <div>
                <td id={`project-content-${rowIndex}`} style={{
                    backgroundColor: 'inherit'
                }}>
                    <span
                        style={{
                            overflowWrap: 'break-word',
                            minWidth: '100%',
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            wordBreak: 'break-word',
                        }}>{`${rowData?.client.name}`}</span>
                </td>

            </div>
        );
    }


    getProjectColumn(rowData, prop) {
        const { rowIndex } = prop;

        return (
            <div>
                <td id={`project-span-${rowIndex}`}
                    style={{
                        backgroundColor: 'inherit'
                    }}>
                    <span
                        style={{
                            overflowWrap: 'break-word',
                            minWidth: '100%',
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            wordBreak: 'break-word',
                        }}>{`${rowData?.project.name}`}</span>
                </td>
            </div>
        );
    }

    getActionsColumn(rowData, prop) {
        const { rowIndex } = prop;
        const isRowActive = this.props.viewMode === 'EDIT';

        return (
            <div style={{ display: 'flex', justifyContent: 'start', maxWidth: '60px', marginLeft: '10px' }}>
                {isRowActive ?

                    <ActionLink
                        iconName='mdi mdi-delete'
                        iconSize='icon-medium'
                        id='delete-icon'
                        handleClick={(e) => {
                            this.handleDeleteActivity(rowData, rowIndex)
                        }}
                        color='black'
                        classN
                        ame='edit-blue-link'
                        key={'delete-button'}
                    /> : null
                }
            </div>
        )
    }

    getIsActive(rowIndex, columnIndex, activeFieldsModel) {
        return (activeFieldsModel?.map[[rowIndex, columnIndex]]) ? true : false;
    }


    onToggleFunction(rowIndex, columnIndex, activeFieldsModel) {
        let data = activeFieldsModel.map;
        if (data[[rowIndex, columnIndex]] === undefined || data[[rowIndex, columnIndex]] === false) {
            data[[rowIndex, columnIndex]] = true;
            this.setState({
                activeFieldsModel: {
                    map: data
                }
            })
        }
    }

    getActivityColumn(rowData, prop) {
        const { rowIndex } = prop;
        return (

            <div>
                <InputDropdownComponent
                    id='activity-input'
                    name='activity'
                    colClass='col-lg-2 col-sm-2 col-md-2'
                    value={rowData?.activity}
                    validator={this.rowValidator}
                    validators={`required|record_already_assigned:${rowIndex}`}
                    label={t('userReporting.activity')}
                    stateField={`element.events[${rowIndex}]`}
                    showLabel={false}
                    options={this.state.activities} //aktywnosci przypisane do projektu
                    onChange={this.handleChange}
                    style={{
                        height: '33px',
                        width: '100%',
                        boxSizing: 'border-box'
                    }}
                    className='custom-dropdown'
                    viewMode={this.props.viewMode}
                    optionLabel='name'
                    dataKey='id'
                    labe={t('userReporting.activity')}
                    placeholder={t('userReporting.activity')}
                    filter
                    filterBy='name'
                    insideTable
                />
            </div>
        );
    }

    getCommentColumn(rowData, prop) {
        return (
            <div className='admin-view-text-area' style={{
                marginTop:'4px'
            }}>
                <InputTextareaComponent
                    id="comment-sc"
                    className='admin-view-text-area'
                    name="comment"
                    colClass="col-xl-14 col-lg-14 col-md-14 col-sm-14"
                    value={rowData.event.comment}
                    stateField={`element.events[${prop.rowIndex}].event`}
                    onChange={this.handleChange}
                    viewMode={this.state.viewMode}
                    maxlength={500}
                    global
                    viewStyle={{ minHeight: '19px', minWidth: '180px', width: 'fit-content', maxWidth: '100%', wordBreak: 'break-word' }}
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                    autoResize
                />
            </div>
        );
    }

    getMinutes(date){
        const hours = moment(date).hours();
        const minutes = moment(date).minutes();
        return moment(new Date()).format('YYYY-MM-DD') + ' ' + hours + ':' + minutes;
    }

    updateListElements(list) {
        const flag = this.isStartEndDateRequired()
        if (flag) {
            list.forEach((x) => {
                    x.event.timeFrom = x.event.timeFrom ? moment(x.event.timeFrom).toDate() : null;
                    x.event.timeTo = x.event.timeTo ? moment(x.event.timeTo).toDate() : null;
            });
        } else {
            list.forEach((x) => {
                    x.event.userTime = x.event.userTime ? moment(x.event.userTime).toDate() : null;
                    x.event.creativeTime = x.event.creativeTime ? moment(x.event.creativeTime) : null
            });
        }
        return this.normalizeListAfterRowEdit(list);
    }


    normalizeListAfterRowEdit(list) {
        //moze byc case ze user zedytuje kilka pol w kilku wierszach
        // i bedzie kazdy wiersz po kolei zapisywac 
        // przy zapisie edycji jest refresh listy wiec juz po jednym zapisie wszystkim polom przypisana zostanie wartosc z bazy 
        // i user bedzie musial od nowa edytowac.
        let rowsToIgnore = []
        const data = this.state.activeFieldsModel.map;
        for (const [key, value] of Object.entries(data)) {
            const arr = key.split(',').map(Number);
            if (value) { //jesli dla danej kolumny jest ustawione true
                rowsToIgnore.push(
                    arr[0] //dodaj, ktory wiersz nalezy "zignorowac"
                );
            }
        }
        const currentList = this.state.element.events; //obecne wartosci z listy
        return list.map((valueFromDb, index) =>
            rowsToIgnore.includes(index) ? currentList[index] : valueFromDb
            //jesli indeks matchuje sie z wierszem do "zignorowania", ustaw wartosc ze state else wez zaktualizowana wartosc
        ); //wtedy po zapisie user zachowa zmiany w innych edytowanych wierszach
    }


    getUserTimeColumn(rowData, prop) {
        const { rowIndex } = prop;
        const { column } = prop;

        rowData.event.userTime = rowData.event.userTime ? moment(rowData.event.userTime).toDate() : null;
        rowData.event.timeFrom = rowData.event.timeFrom ? moment(rowData.event.timeFrom).toDate() : null;
        rowData.event.timeTo = rowData.event.timeTo ? moment(rowData.event.timeTo).toDate() : null;

        const startEndRequired = this.isStartEndDateRequired();
        const width = startEndRequired ? '140px' : '70px';

        let formattedUserTime = '';
        if (startEndRequired) {
            formattedUserTime = rowData.event.timeFrom && rowData.event.timeTo ? `${moment(rowData.event.timeFrom).format('H:mm')}-${moment(rowData.event.timeTo).format('H:mm')}` : ``;
        } else {
            formattedUserTime = moment(rowData.event.userTime).format('HH:mm');
        }
        return (
            <div id='user-time-inplace'>
                <div style={{ display: 'flex', justifyContent: 'start', padding: 0, width: '65px', maxWidth: '65px' }}>
                    {!startEndRequired ? (
                        <InputCalendarComponent
                            id={`usertime-content-${rowIndex}`}
                            name={'userTime'}
                            value={rowData.event.userTime}
                            stateField={`element.events[${rowIndex}].event`}
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                            showLabel={false}
                            insideTable
                            showTime
                            validator={this.rowValidator}
                            label={t('userReporting.workTime')}
                            dateFormatMoment='HH:mm'
                            className='user-reporting-time-style'
                            timeOnly
                            validateViewMode={true}
                            placeholder=''
                            showSeconds={false}
                            showIcon={false}
                            icon={() => <i className='clock' />}
                            readOnlyInput={false}
                            propCustomValue={true}
                            mask='99:99'
                            style={{
                                height: '34px',
                                maxWidth: '50px',
                                width: '60px',
                                boxSizing: 'border-box'
                            }}
                            showOnFocus={false}
                            customTimePicker={(e) => {
                            }}
                            onInputClick={this.onInputClick}
                            trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                        />
                    ) : (
                        <div style={{ minWidth: width, '--bs-gutter-x': '0.2rem' }} className='row'>
                            <div className='col'>
                                <InputCalendarComponent
                                    id={`time-from-input-inside-list-${rowIndex}`}
                                    name={`timeFrom`}
                                    value={rowData.event.timeFrom}
                                    stateField={`element.events[${rowIndex}].event`}
                                    onChange={this.handleChange}
                                    viewMode={this.props.viewMode}
                                    showLabel={false}
                                    insideTable
                                    showTime
                                    validator={this.rowValidator}
                                    label={t('userReporting.workTime')}
                                    dateFormatMoment='HH:mm'
                                    className='user-reporting-time-style'
                                    timeOnly
                                    validators={`more_than_zero_row:${rowIndex}|from_to_row_validation:${rowIndex}`}
                                    validateViewMode={true}
                                    placeholder=''
                                    showSeconds={false}
                                    showIcon={false}
                                    icon={() => <i className='clock' />}
                                    readOnlyInput={false}
                                    propCustomValue={true}
                                    mask='99:99'
                                    style={{
                                        height: '34px',
                                        maxWidth: '50px',
                                        width: '60px',
                                        boxSizing: 'border-box'
                                    }}
                                    showOnFocus={false}
                                    customTimePicker={(e) => {
                                    }}
                                    onInputClick={this.onInputClick}
                                    trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                                />
                            </div>
                            <div className='col'>
                                <InputCalendarComponent
                                    id={`time-to-input-inside-list-${rowIndex}`}
                                    name={`timeTo`}
                                    value={rowData.event.timeTo}
                                    stateField={`element.events[${rowIndex}].event`}
                                    onChange={this.handleChange}
                                    viewMode={this.props.viewMode}
                                    showLabel={false}
                                    insideTable
                                    className='user-reporting-time-style'
                                    showTime
                                    validator={this.rowValidator}
                                    validators={`more_than_zero_row:${rowIndex}|from_to_row_validation:${rowIndex}`}
                                    validateViewMode={true}
                                    dateFormatMoment='HH:mm'
                                    timeOnly
                                    placeholder=''
                                    mask='99:99'
                                    showSeconds={false}
                                    showIcon={false}
                                    icon={() => <i className='clock' />}
                                    readOnlyInput={false}
                                    propCustomValue={true}
                                    style={{
                                        height: '34px',
                                        maxWidth: '50px',
                                        width: '60px',
                                        boxSizing: 'border-box'
                                    }}
                                    customTimePicker={(e) => {
                                    }}
                                    onInputClick={this.onInputClick}
                                    trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    isCreativeTimeColumnRequired() {
        const isStartEndNotRequired = !this.isStartEndDateRequired(); //tylko dla opcji z wpisywaniem ilości godzin
        const userHasPernamentContract = this.state.element.userContractType === 'PERNAMENT';//i tylko kiedy sprawdzany uzytkownik ma umowe o prace
        return this.authService.getProfile().featureCreativeWorkReportingEnabled && isStartEndNotRequired && userHasPernamentContract 
    }

    creativeTimeTemplate(rowData, props) {
        return (
            <div className='col-sm'>
                <InputCalendarComponent
                    id={'creativeTime-add-row'}
                    name={'creativeTime'}
                    value={this.state.newElement?.event?.creativeTime}
                    stateField={'newElement.event'}
                    onChange={this.handleChange}
                    viewMode={this.props.viewMode}
                    label={t('userReporting.creativeTime')}
                    showLabel={false}
                    insideTable
                    showTime
                    className='user-reporting-time-style'
                    dateFormatMoment='HH:mm'
                    timeOnly
                    validateViewMode={false}
                    placeholder='HH:mm'
                    showSeconds={false}
                    showIcon={false}
                    validator={this.addRowValidator}
                    validators={'creative_time_validation'}
                    icon={() => <i className='clock' />}
                    readOnlyInput={false}
                    mask='99:99'
                    propCustomValue={true}
                    style={{
                        height: '34px',
                        width: '50px',
                        maxWidth: '50px'
                    }}
                    showOnFocus={false}
                    customTimePicker={(e)=>{
                    }}
                    onInputClick={this.onInputClick}
                    trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                />
            </div>
        );
    }

    getCreativeTimeColumn(rowData, prop) {
        const { rowIndex } = prop;
        const { column } = prop;

        rowData.event.creativeTime = rowData.event.creativeTime ? moment(rowData.event.creativeTime).toDate() : null;

        let formattedUserTime = '';
        const isCreativeTimeNotReported = !rowData.event.creativeTime || rowData.event?.creativeTime === 0;

        formattedUserTime = isCreativeTimeNotReported ? '00:00' : moment(rowData.event.creativeTime).format('HH:mm');

        return (
            <div id={`creative-time-${rowIndex}`} >
                <div style={{ display: 'flex', justifyContent: 'start', padding: 0, width: '65px', maxWidth: '65px' }}>
                    {(
                        <InputCalendarComponent
                            id={`creativeTime-content-${rowIndex}`}
                            name={'creativeTime'}
                            value={rowData.event.creativeTime}
                            stateField={`element.events[${rowIndex}].event`}
                            onChange={this.handleChange}
                            viewMode={this.props.viewMode}
                            showLabel={false}
                            insideTable
                            showTime
                            validator={this.rowValidator}
                            validators={`creative_time_validation:${rowIndex}`}
                            label={t('userReporting.creativeTime')}
                            dateFormatMoment='HH:mm'
                            className='user-reporting-time-style'
                            timeOnly
                            validateViewMode={true}
                            placeholder='HH:mm'
                            showSeconds={false}
                            showIcon={false}
                            icon={() => <i className='clock' />}
                            readOnlyInput={false}
                            propCustomValue={true}
                            mask='99:99'
                            style={{
                                height: '34px',
                                maxWidth: '50px',
                                width: '60px',
                                boxSizing: 'border-box'
                            }}
                            showOnFocus={false}
                            customTimePicker={(e) => {
                            }}
                            onInputClick={this.onInputClick}
                            trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                        />
                    )}
                </div>
            </div>
        );
    }


    prepareColumns() {
        const startEndRequired = this.isStartEndDateRequired();
        const creativeTimeColumnRequired = this.isCreativeTimeColumnRequired()

        let columns = [
            {
                field: 'client.name',
                header: t('userReporting.client'),
                body: this.getClientColumn.bind(this),
                width: '130px'
            },
            {
                field: 'project.name',
                header: t('userReporting.project'),
                body: this.getProjectColumn.bind(this),
                width: '120px'
            },
            {
                field: 'activity.name',
                header: t('userReporting.activity'),
                body: this.getActivityColumn.bind(this),
                width: '150px'
            },
            {
                field: 'comment',
                header: t('userReporting.comment'),
                body: this.getCommentColumn.bind(this),
                width:'100%'
            },
            {
                field: 'userTime',
                header: startEndRequired ? t('userReporting.hours') : t('userReporting.workTime'),
                body: this.getUserTimeColumn.bind(this),
                width: startEndRequired && !creativeTimeColumnRequired  ? '140px' : '65px'
            },
        ];

        if(creativeTimeColumnRequired){
            columns.push({
                field: 'creativeTime',
                header: 'Praca twórcza',
                body: this.getCreativeTimeColumn.bind(this),
                width: '65px'
            });
        }

        columns.push({
            field:'',
            header: '',
            body: this.getActionsColumn.bind(this),
            width: '155px'
        });

        return columns;
    }
    
    setElement() {
        const { viewMode } = this.props;

        const { day } = this.state.element;
        const { projectId } = this.state;
        const { userId } = this.state;
        if (projectId && day && userId && (viewMode === 'EDIT' || viewMode === 'VIEW')) {
            this.blockUi();
            this.service
                .get(day, projectId, userId)
                .then((data) => {
                    this.setState({ loading: false }, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({ loading: false }, this.initAfterSetElement());
        }
    }


    refreshTable() {
        this.setElement()
    }

    closeOpenInplaceComponents(data, rowIndex) {
        for (const [key, value] of Object.entries(data)) {
            const arr = key.split(',').map(Number);
            if (arr[0] === rowIndex) {
                data[[arr[0], arr[1]]] = false; //"zamknij" wszystkie inplace z danego wiersza
            }
        }
    }

    handleDeleteActivity(rowData, rowIndex) {
        let data = this.state.activeFieldsModel.map;
        this.closeOpenInplaceComponents(data, rowIndex);

        let events = this.state.element.events.filter(x => x.event !== rowData.event)
        this.setState((prev) => ({
            loading: false,
            activeFieldsModel: {
                map: data
            },
            element:{
                ...prev.element,
                events: events
            }
        }))
    }


    handleEditActivity(rowData, rowIndex) {
        if (this.rowValidator.allValid()) {

            let data = this.state.activeFieldsModel.map;
            this.closeOpenInplaceComponents(data, rowIndex);
            this.setState({
                loading: false,
                activeFieldsModel: {
                    map: data
                }
            });
        } else {
            this.rowValidator.showMessages();
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    handleAddNewActivity() {
        const { newElement } = this.state;
        if (this.addRowValidator.allValid()) {
            let events = this.state.element.events;
            events.push(this.cloneElement(newElement));

            this.setState(
                {
                    loading: true,
                }, () => {
                    this.setState((prev) => ({
                        loading: false,
                        element: {
                            ...prev.element,
                            events: events
                        },
                        newElement: {
                            client: prev.newElement.client,
                            project: prev.newElement.project,
                            activity: undefined,
                            event: {
                                status: {
                                    label: 'Do akceptacji',
                                    enumValue: 'TO_APPROVE'
                                },
                                userTime: undefined,
                                timeFrom: undefined,
                                timeTo: undefined,
                                comment: undefined,
                            }
                        },
                    }), () => {
                        this.addRowValidator.hideMessages()
                    });
                }
            );
        } else {
            this.addRowValidator.showMessages();
            this.scrollToError = true;
            this.forceUpdate();
        }
    }

    isRowActive(rowIndex) {
        const data = this.state.activeFieldsModel.map;
        for (const [key, value] of Object.entries(data)) {
            const arr = key.split(',').map(Number);
            if (arr[0] === rowIndex && data[[arr[0], arr[1]]]) { //jesli dla danej kolumny jest ustawione true
                return true;
            }
        }
        return false;
    }


    isStartEndDateRequired() {
        return this.authService.getProfile().timeReportingStartEndDateRequired
    }

    disableAllInplaceComponents(){

    }

    footerGroup() {
        return this.renderAddRow();
    }


    generateCustomFooterIfPossible() {
        return this.footerGroup();
    }

    fromToUserTimeTemplate(rowData, props) {
        // FROM - TO, 8 am - 2 pm.
        const rowIndex = props?.rowIndex;
        return (
            <div style={{ '--bs-gutter-x': '0.2rem', width: '140px' }} className='row'>
                <div className='col-sm'>
                    <InputCalendarComponent
                        id={`user-time-from-${rowIndex}`}
                        name={`timeFrom`}
                        value={this.state.newElement.event.timeFrom}
                        stateField={'newElement.event'}
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                        showLabel={false}
                        insideTable
                        showTime
                        validator={this.addRowValidator}
                        validateViewMode={false}
                        validators={'required|from_to_validation'}
                        dateFormatMoment='HH:mm'
                        className='user-reporting-time-style'
                        timeOnly
                        placeholder=''
                        showSeconds={false}
                        showIcon={false}
                        icon={() => <i className='clock' />}
                        readOnlyInput={false}
                        label={t('userReporting.timeFrom')}
                        propCustomValue={true}
                        mask='99:99'
                        style={{
                            height: '34px',
                            maxWidth: '100%',
                            width: '100%',
                            boxSizing: 'border-box',
                            position: 'static'
                        }}
                        customTimePicker={(e)=>{
                        }}
                        onInputClick={this.onInputClick}
                        trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                    />
                </div>
                <div className='col-sm'>
                    <InputCalendarComponent
                        id={`user-time-to-${rowIndex}`}
                        name={`timeTo`}
                        value={this.state.newElement.event.timeTo}
                        stateField={'newElement.event'}
                        onChange={this.handleChange}
                        viewMode={this.props.viewMode}
                        showLabel={false}
                        insideTable
                        showTime
                        validator={this.addRowValidator}
                        validateViewMode={false}
                        validators={'required|from_to_validation'}
                        dateFormatMoment='HH:mm'
                        timeOnly
                        placeholder=''
                        className='user-reporting-time-style'
                        showSeconds={false}
                        showIcon={false}
                        icon={() => <i className='clock' />}
                        readOnlyInput={false}
                        label={t('userReporting.timeTo')}
                        propCustomValue={true}
                        mask='99:99'
                        style={{
                            height: '34px',
                            maxWidth: '100%',
                            width: '100%',
                            boxSizing: 'border-box',
                            position: 'static'
                        }}
                        customTimePicker={(e)=>{                                           
                        }}
                        onInputClick={this.onInputClick}
                        trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                    />
                </div>
            </div>
        );
    }

    userTimeTemplate(rowData, props) {
        return (
            <div className='col-sm'>
                <InputCalendarComponent
                    id={'usertime-add-row'}
                    name={'userTime'}
                    value={this.state.newElement.event.userTime}
                    stateField={'newElement.event'}
                    onChange={this.handleChange}
                    viewMode={this.props.viewMode}
                    label={t('userReporting.workTime')}
                    showLabel={false}
                    insideTable
                    showTime
                    className='user-reporting-time-style'
                    dateFormatMoment='HH:mm'
                    timeOnly
                    placeholder='HH:mm'
                    showSeconds={false}
                    showIcon={false}
                    validator={this.addRowValidator}
                    validateViewMode={false}
                    validators={'time_validation'}
                    icon={() => <i className='clock' />}
                    readOnlyInput={false}
                    mask='99:99'
                    propCustomValue={true}
                    style={{
                        height: '34px',
                        width: '50px',
                        maxWidth: '50px'
                    }}
                    showOnFocus={false}
                    customTimePicker={(e)=>{        
                    }}
                    onInputClick={this.onInputClick}
                    trapFocusOnTabClick={false} //mozna przejsc dalej tabem
                />
            </div>
        );
    }

    formattedTimeToMinutes(time) {
        const split = time.split(':');
        return (Number(split[0] * 60)) + Number(split[1])
    }

    getSummary(list) {
        const startEndRequired = this.isStartEndDateRequired()
        let mappedList = []
        if (startEndRequired) {
            mappedList = list.map((x) => {
                return this.formattedTimeToMinutes(moment(x.event.timeTo).format('HH:mm')) - this.formattedTimeToMinutes(moment(x.event.timeFrom).format('HH:mm'))
            })
        } else {
            mappedList = list.map((x) => this.formattedTimeToMinutes(moment(x.event.userTime).format('HH:mm')))
        }
        let totalMinutes = 0;
        for (let i = 0; i < mappedList.length; i++) {
            totalMinutes += mappedList[i];
        }

        let creativeTimeSummary = 0;
        let creativeTimeList = list.filter(x => x.event.creativeTime).map((x) => this.formattedTimeToMinutes(moment(x.event.creativeTime).format('HH:mm')))
        for (let i = 0; i < creativeTimeList.length; i++) {
            creativeTimeSummary += creativeTimeList[i];
        }

        return {
            totalMinutes: totalMinutes,
            creativeTimeSummary: creativeTimeSummary
        }
    }


    renderAddRow() {
        const startEndRequired = this.isStartEndDateRequired();
        const renderTime = startEndRequired ? this.fromToUserTimeTemplate() : this.userTimeTemplate()

        const summary = this.getSummary(this.state.element?.events);

        const formattedSummary = this.formatTime(summary?.totalMinutes)
        const formattedCreativeTimeSummary = this.formatTime(summary?.creativeTimeSummary)
        const creativeTimeColumnRequired = this.isCreativeTimeColumnRequired();


        return <ColumnGroup>
            {this.state?.element?.events?.length >= 1 ?
                <Row>
                    <Column footer="Podsumowanie" colSpan={1} footerStyle={{ textAlign: "left" }} />
                    <Column footer="" colSpan={3} footerStyle={{ textAlign: "right" }} />
                    <Column
                        style={{ whiteSpace: "nowrap" }}
                        footer={
                            summary?.totalMinutes
                                ? `${formattedSummary} / 8h`
                                : "00:00 / 8h"
                        }
                        footerStyle={{ textAlign: "left" }}
                    />
                    {creativeTimeColumnRequired ?
                        <Column
                            style={{ whiteSpace: "nowrap" }}
                            footer={
                                summary.creativeTimeSummary
                                    ? `${formattedCreativeTimeSummary} / 8h`
                                    : "00:00 / 8h"
                            }
                            footerStyle={{ textAlign: "left" }}
                        />
                        : null}
                    <Column />
                </Row>
                : null}
            {this.state?.element?.events?.length === 0 ?
                <Row>
                    <Column footer="Brak danych do wyświetlenia - Dodaj nowy wpis" colSpan={creativeTimeColumnRequired ? 7 : 6} footerStyle={{ textAlign: "center", backgroundColor: 'white' }} />
                </Row>
                : null
            }
            {this.state.viewMode === 'EDIT' ?
                <Row>
                    <Column footer="Nowy wpis" colSpan={creativeTimeColumnRequired ? 7 : 6} footerStyle={{ textAlign: "left", color: 'gray', backgroundColor: 'white', border: 'white' }} />
                </Row> : null
            }
                {this.state.viewMode === 'EDIT' ?
                    <Row>
                        <Column style={{
                            width: '100px',
                            maxWidth: '150px',
                            position: 'static',
                            border: 'white'
                        }} colSpan={2} footer={() => {
                            //PROJEKT
                            return (
                                <InputDropdownComponent
                                    id='project-row'
                                    name='project'
                                    value={this.state.newElement.project}
                                    validator={this.addRowValidator}
                                    options={[this.state.project]}
                                    viewMode={this.props.viewMode}
                                    optionLabel='name'
                                    dataKey='id'
                                    validators='required|record_already_assigned'
                                    label={t('userReporting.project')}
                                    showLabel={false}
                                    placeholder={t('userReporting.project')}
                                    filter
                                    filterBy='name'
                                    className='custom-dropdown'
                                    insideTable
                                    disabled
                                    style={{
                                        height: '33px',
                                        maxWidth: '100%',
                                        width: '100%',
                                        boxSizing: 'border-box',
                                    }}
                                />
                            )
                        }}
                        />
                        <Column
                            style={{
                                position: 'static',
                                border: 'white'
                            }}
                            footer={() => {
                                //AKTYWNOŚĆ
                                return (
                                    <InputDropdownComponent
                                        id='activity'
                                        name='activity'
                                        value={this.state.newElement?.activity}
                                        colClass='col-xl-12 col-lg-12 col-md-12 col-sm-12'
                                        options={this.state.activities}
                                        // aktywnosci przypisane do projektu
                                        label={t('userReporting.activity')}
                                        showLabel={false}
                                        onChange={(a, b, c, d) => {
                                            let newElement = this.state.newElement;
                                            newElement.activity = c.target.value
                                            this.setState({
                                                newElement: newElement
                                            })
                                        }}
                                        viewMode={this.props.viewMode}
                                        optionLabel='name'
                                        dataKey='id'
                                        className='custom-dropdown'
                                        validator={this.state.newElement.project === undefined ? null : this.addRowValidator}
                                        validators='required|record_already_assigned'
                                        placeholder={t('userReporting.activity')}
                                        filter
                                        filterBy='name'
                                        insideTable
                                        disabled={this.state.newElement.project === undefined}
                                        style={{
                                            height: '33px',
                                            maxWidth: '100%',
                                            width: '100%',
                                            boxSizing: 'border-box'
                                        }}
                                    />
                                )
                            }}
                        />
                        <Column
                            style={{
                                position: 'static',
                                border: 'white'
                            }}
                            footer={() => {
                                //KOMENTARZ
                                return (
                                    <div className='admin-view-text-area' style={{
                                        marginTop:'5px'
                                    }}>
                                        <InputTextareaComponent
                                            id="comment-sc"
                                            name="comment"
                                            colClass="col-xl-12 col-lg-12 col-md-12 col-sm-12"
                                            value={this.state.newElement.event.comment}
                                            stateField={'newElement.event'}
                                            viewMode={this.state.viewMode}
                                            onChange={this.handleChange}
                                            maxlength={500}
                                            global
                                            refreshFromBackend
                                            timeoutHandler={this.refreshTable}
                                            autoResize
                                        />
                                    </div>
                                )
                            }}
                        />
                        <Column
                            style={{
                                border: 'white'
                            }}
                            footer={() => {
                                return (
                                    <div>
                                        {renderTime}
                                        <div
                                            style={{
                                                position: 'absolute',
                                                marginTop: '3px'
                                            }}
                                        >
                                            <span>{this.addRowValidator.message('', '', '', 'time_validation|from_to_validation|creative_time_validation')}</span>

                                        </div>
                                    </div>
                                );
                            }}
                        />
                        {creativeTimeColumnRequired ?
                            <Column
                                style={{
                                    border: 'white'
                                }}
                                footer={() => {
                                    return (
                                        <div>
                                            {this.creativeTimeTemplate()}
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    marginTop: '3px'
                                                }}
                                            >
                                            </div>
                                        </div>
                                    );
                                }}
                            /> : null
                        }
                        <Column
                            style={{
                                border: 'white'
                            }}
                            footer={() => (
                                <div id='addRowButton'>
                                    <ActionButton
                                        label="Dodaj wpis"
                                        handleClick={this.handleAddNewActivity.bind(this)}
                                        style={{ width: "fit-content" }}
                                    />
                                </div>
                            )}
                        />
                    </Row>
                    : null}
            </ColumnGroup>
    }    
    
    isEmptyList() {
        return this.state.element.events.length === 0;
    }

    renderDetails() {
        const isEmpty = this.isEmptyList();
        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <DivContainer colClass='col-md-12'>
                        <Card>
                            <DivContainer colClass='row'>
                                <InputCalendarComponent
                                    id='day'
                                    name='day'
                                    label={t('project.date')}
                                    value={this.state.element.day}
                                    stateField={'element'}
                                    colClass='col-md-4'
                                    onChange={this.handleChange}
                                    viewMode={this.props.viewMode}
                                    validator={this.validator}
                                    validators='required'
                                    showIcon
                                    showClear
                                    showTime={false}
                                    propCustomValue={true}
                                />

                                <InputTextComponent
                                    id='level'
                                    name='level'
                                    label={t('global.status')}
                                    colClass='col-md-4'
                                    value={this.state.element.status}
                                    validators='required|max:150'
                                    validator={this.validator}
                                    onChange={this.handleChange}
                                    viewMode={'VIEW'}
                                    renderValue={(e) => {
                                        return e?.label;
                                    }}
                                    rendered={this.props.viewMode !== 'NEW'}
                                />
                            </DivContainer>
                            <DivContainer colClass='row'>
                                <InputTextComponent
                                    id='status'
                                    label={t('global.user')}
                                    colClass='col-md-4'
                                    value={this.state.element.userName}
                                    validators='required|max:150'
                                    validator={this.validator}
                                    onChange={this.handleChange}
                                    viewMode={'VIEW'}
                                    rendered={true}
                                />
                                <InputTextComponent
                                    id='level'
                                    name='level'
                                    label={t('reportedDay.level')}
                                    colClass='col-md-4'
                                    value={this.state.element?.levelName}
                                    validators='required|max:150'
                                    validator={this.validator}
                                    onChange={this.handleChange}
                                    viewMode={'VIEW'}
                                    rendered={this.props.viewMode !== 'NEW'}
                                />
                            </DivContainer>
                        </Card>
                    </DivContainer>
                    {this.canViewCardDetails() ? (
                        <DivContainer colClass='col-md-12'>
                            <TabView
                                activeIndex={this.state.activeIndex}
                                onTabChange={(e) => {
                                    const url = `${this.props.elementId}?day=${this.state.day}&projectId=${this.state.projectId}&userId=${this.state.userId}&activeIndex=${e.index}`
                                    this.setState({activeIndex: e.index}, () => {
                                        this.props.history.push(url);
                                    });
                                }}
                            >
                                <TabPanel header={'Aktywności'}>
                                    <Card header='Aktywności'>
                                        <DivContainer colClass='row'>
                                            <DataTable
                                                id='dataTable'
                                                value={this.state.element.events}
                                                sortField='id'
                                                emptyMessage={t('list.empty')}
                                                className={isEmpty ? 'empty-table' : 'fixed-datatable'}
                                                footerColumnGroup={this.generateCustomFooterIfPossible()}
                                                responsiveLayout='scroll'
                                                tableStyle={{
                                                    'table-layout': 'fixed',
                                                    minWidth:'850px'
                                                }}
                                                rowClassName={(rowData, obj) => {
                                                    const acceptLevel = rowData.event.acceptLevel
                                                    const isUserApproved = acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL //&& acceptLevel !== Constants.PM_APPROVED_LEVEL
                                                    const isPmApproved = acceptLevel === Constants.PM_APPROVED_LEVEL
                                                    return isUserApproved ? {
                                                        'user-approved-row': true
                                                    } : (isPmApproved ? {
                                                        'pm-approved-row': true
                                                    } : null)
                                                }}
                                            >
                                                {this.prepareColumns().map((col, index) => {
                                                    return (
                                                        <Column
                                                            selectionMode={col.selectionMode}
                                                            key={col.key ? col.key : col.field}
                                                            field={col.field}
                                                            filter
                                                            filterField={col.field}
                                                            showFilterMenu={false}
                                                            header={col.header}
                                                            body={col.body}
                                                            bodyClassName={col.bodyClassName}
                                                            headerClassName={col.headerClassName}
                                                            className={col.className}
                                                            sortable={col.sortable}
                                                            sortField={col.sortField !== undefined ? col.sortField : col.field}
                                                            style={col.style !== undefined ? col.style : col.width !== undefined ? { width: col.width, maxWidth: col.width } : null}
                                                            bodyStyle={col.bodyStyle}
                                                            columnIndex={index}
                                                        />
                                                    );
                                                })}
                                            </DataTable>
                                        </DivContainer>
                                    </Card>
                                </TabPanel>
                                {this.props.viewMode !== 'NEW' ? (
                                    <TabPanel header={t('logEntry.list.title')}>
                                        {this.state.element?.userDayId ?
                                            <LogEntryListContainer
                                                objectType='USER_DAY'
                                                objectId={this.state.element.userDayId}
                                                expandFilters={false}
                                                renderHeader={false}
                                            />
                                            :
                                            null}
                                    </TabPanel>
                                ) : null}                                
                            </TabView>
                        </DivContainer>
                    ) : null}
                </DivContainer>                
                {this.state.showConfirmRejectDialog ? (
                    <YesNoDialog
                        visible={this.state.showConfirmRejectDialog}
                        header={t('userReporting.rejectHeader')}
                        name='visible'
                        childrenDivClassname='row'
                        onChange={(type, x, target) => {
                            if (target.value) {
                                if (this.validator.allValid()) {
                                    this.handleReject();
                                    this.setElement();
                                } else {
                                    this.validator.showMessages();
                                    this.scrollToError = true;
                                    this.forceUpdate();
                                }
                            } else {
                                this.hideRejectConfirmation();
                            }
                        }}
                        style={{
                            width: 'fit-content'
                        }}
                        onHide={() => {
                            this.hideRejectConfirmation();
                        }}
                    >
                        <InputTextareaComponent
                            validator={this.validator}
                            id={'reject-reason-text-area'}
                            label={t('userReporting.reject_reason')}
                            value={this.state.rejectReason}
                            name='rejectReason'
                            showLabel={true}
                            insideTable
                            viewMode={'NEW'}
                            rendered={true}
                            onChange={(a,b,c,d)=>{
                                this.setState({
                                    rejectReason: c.target.value
                                })
                            }}
                            style={{
                                width: '100%',
                            }}
                            maxlength={100}
                            autoResize
                        />

                    </YesNoDialog>
                ) : this.state.showConfirmAcceptDialog ? (
                    <YesNoDialog
                        visible={this.state.showConfirmAcceptDialog}
                        header={t('userReporting.confirmHeader')}
                        name='visible'
                        onChange={(type, x, target) => {
                            if (target.value) {
                                this.handleAcceptUserDay();
                                this.setState({ showConfirmAcceptDialog: false })
                            } else {
                                this.setState({ showConfirmAcceptDialog: false })
                            }
                        }}
                        onHide={() => {
                            this.setState({ showConfirmAcceptDialog: false })
                        }}
                    >
                        {t('userReporting.confirmMessage')}
                    </YesNoDialog>
                ) : this.state.unlockDialogVisible ? (
                    <YesNoDialog
                        visible={this.state.unlockDialogVisible}
                        header={t('userReporting.unlockHeader')}
                        name='visible'
                        onChange={(type, x, target) => {
                            if (target.value) {
                                this.handleUnlockUserDay();
                                this.setState({ unlockDialogVisible: false })
                            } else {
                                this.setState({ unlockDialogVisible: false })
                            }
                        }}
                        onHide={() => this.setState({ unlockDialogVisible: false })}
                    >
                        {t('userReporting.unblockMessage')}
                    </YesNoDialog>
                ) : null}
            </React.Fragment>
        );
    }
}

UserDayDetailsContainer.defaultProps = {
    backUrl: '/#/reported-day-list',
    editUrl: '/#/user-day/edit/',
    detailUrl: '/#/user-day/details/',
    viewMode: 'VIEW'
};

UserDayDetailsContainer.propTypes = {
    backUrl: PropTypes.string,
    viewMode: PropTypes.string
};

export default withRouter(withTranslation()(UserDayDetailsContainer));
